<div class="qr-decode-wrapper">
  <!-- Top Navigation / Brand Header -->
  <div class="row no-row-margin no-print">
    <div class="col-12 p-0">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title d-flex align-items-center">
          <img src="/assets/menu/enterprise/logo-enterprise.svg" alt="BarCloud" class="header-brand-logo me-2" />
          <span class="header-title-text">QR Label Viewer</span>
        </div>

        @if (!hasError && fields.length > 0) {
          <div class="transaction-section-header-actions header-actions">
            <button class="asap-btn" kendoButton (click)="toggleViewMode()">
              <span><img [src]="'/assets/menu/' + _theme + '/preview-files.svg'" onerror="this.src='/assets/menu/enterprise/preview-files.svg'" /></span>
              {{ showRaw ? 'Formatted View' : 'Raw Data' }}
            </button>
            <button class="asap-btn" kendoButton (click)="copyAllToClipboard()">
              <span><img [src]="copiedAll ? '/assets/menu/' + _theme + '/ok-icon.svg' : '/assets/menu/' + _theme + '/copy-report-icon.svg'" onerror="this.src='/assets/menu/enterprise/copy-report-icon.svg'" /></span>
              {{ copiedAll ? 'Copied!' : 'Copy All' }}
            </button>
            <button class="asap-btn" kendoButton (click)="printRecord()">
              <span><img [src]="'/assets/menu/' + _theme + '/print-icon.svg'" onerror="this.src='/assets/menu/enterprise/print-icon.svg'" /></span>
              Print
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Main Container -->
  <div class="container-fluid py-4 px-3 px-md-5">
    <!-- Error State -->
    @if (hasError) {
      <div class="unlicensedContainer mx-auto">
        <div class="form_center text-center">
          <div class="imagoLogin">
            <img src="/assets/menu/enterprise/logo-enterprise.svg" alt="Enterprise Logo" />
          </div>
          <h2 class="loginProjectTitle mb-3">No QR Code Data Available</h2>
          <div class="unlicensed-message-box text-start">
            <p class="description">
              {{ errorMessage || 'Please ensure you are opening a valid BarCloud QR code URL with a base64 encoded query payload.' }}
            </p>
          </div>
          <div class="url-hint-box text-start mb-2">
            <span class="titleStandardStyle d-block mb-1">Expected URL Format:</span>
            <code class="text-break">https://domain/decode-qr?qrcode=&lt;Base64Data&gt;</code>
          </div>
        </div>
      </div>
    }

    <!-- Success State: Record Card -->
    @if (!hasError && fields.length > 0) {
      <div class="row justify-content-center">
        <div class="col-12 col-xl-10">
          <div class="transactionWidget">
            <!-- Widget Section Header -->
            <div class="row">
              <div class="col-12 sectionheader d-flex justify-content-between align-items-center">
                <span class="titleStandardStyle mb-0 d-flex align-items-center">
                  <img [src]="'/assets/menu/' + _theme + '/public-qr-icon.svg'" onerror="this.src='/assets/menu/enterprise/public-qr-icon.svg'" class="widget-title-icon me-2" />
                  {{ reportName || 'Label Details' }}
                </span>
                <span class="scan-meta-badge">
                  @if (labelId) {
                    Label #: {{ labelId }} &bull;
                  }
                  @if (reportCategoryId) {
                    Category: {{ reportCategoryId }} &bull;
                  }
                  {{ fields.length }} Field{{ fields.length > 1 ? 's' : '' }} &bull; Scanned: {{ scannedAt | date:'medium' }}
                </span>
              </div>
            </div>
            <div class="section-separator my-3"></div>
            <!-- Formatted Key-Value View -->
            @if (!showRaw) {
              <div class="row">
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0 qr-fields-table">
                      <tbody>
                        @for (field of fields; track field; let idx = $index) {
                          <tr class="field-row">
                            <td class="field-label-col">
                              <div class="d-flex align-items-center">
                                <span class="field-bullet me-2"></span>
                                <label class="control-label mb-0 fw-bold">{{ field.key || 'Value' }}</label>
                              </div>
                            </td>
                            <td class="field-value-col">
                              <div class="d-flex justify-content-between align-items-center gap-2">
                                <span class="field-value-text">{{ field.value || '—' }}</span>
                                <button class="asap-btn-icon no-print" title="Copy value" (click)="copyFieldValue(field, idx)">
                                  <img [src]="copiedIndex === idx ? '/assets/menu/' + _theme + '/ok-icon.svg' : '/assets/menu/' + _theme + '/copy-report-icon.svg'"
                                    onerror="this.src='/assets/menu/enterprise/copy-report-icon.svg'" />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              }
              <!-- Raw Data View -->
              @if (showRaw) {
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <span class="titleStandardStyle mb-0">Decoded Payload Text:</span>
                      <button class="asap-btn no-print" kendoButton (click)="copyAllToClipboard()">
                        <span><img [src]="copiedAll ? '/assets/menu/' + _theme + '/ok-icon.svg' : '/assets/menu/' + _theme + '/copy-report-icon.svg'" onerror="this.src='/assets/menu/enterprise/copy-report-icon.svg'" /></span>
                        Copy Raw
                      </button>
                    </div>
                    <pre class="raw-data-box"><code>{{ decodedText }}</code></pre>
                  </div>
                </div>
              }
              <!-- Footer / Bottom Actions -->
              <div class="section-separator my-3 no-print"></div>
              <div class="row align-items-center no-print">
                <div class="col-12 col-sm-6 text-muted font-size-12">
                  BarCloud Inventory & Asset Tracking
                </div>
                <div class="col-12 col-sm-6 text-sm-end mt-2 mt-sm-0">
                  <button class="asap-btn" kendoButton (click)="copyAllToClipboard()">
                    <span><img [src]="copiedAll ? '/assets/menu/' + _theme + '/ok-icon.svg' : '/assets/menu/' + _theme + '/copy-report-icon.svg'" onerror="this.src='/assets/menu/enterprise/copy-report-icon.svg'" /></span>
                    {{ copiedAll ? 'Copied' : 'Copy All Details' }}
                  </button>
                  <button class="asap-btn" kendoButton (click)="printRecord()">
                    <span><img [src]="'/assets/menu/' + _theme + '/print-icon.svg'" onerror="this.src='/assets/menu/enterprise/print-icon.svg'" /></span>
                    Print
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
